export default __webpack_public_path__ + "static/media/lisa-marie-jung.dea21207.jpg";